export enum FunctionType {
  GetAuthToken = 'GetAuthToken',
  SendPageLoadPerfMetrics = 'yammerPageLoadPerfMetrics',
  SetYammerPageTitle = 'setYammerPageTitle',
  SendReactionUpdates = 'yammerSocialReactionSync',
  SetCachedItem = 'setCachedItem',
  RemoveCachedItem = 'removeCachedItem',
}

export interface MessageRequest {
  readonly id: number;
  readonly func: FunctionType;
  readonly args?: string[];
  readonly data?: Record<string, unknown>;
}

export interface TokenResponse {
  readonly success: boolean;
  readonly token?: string;
  readonly error?: string;
}

interface MessageResponse {
  readonly id: number;
}

export interface GetAuthTokenResponse extends MessageResponse {
  readonly tokenResponses: TokenResponse[];
}

/* eslint-disable @typescript-eslint/naming-convention */
export enum HostClientType {
  android = 'android',
  ios = 'ios',
}
/* eslint-enable @typescript-eslint/naming-convention */

export interface Context {
  /**
   * The current locale that the user has configured for the app formatted as
   * languageId-countryId (for example, en-us).
   */
  readonly locale: string;
  /**
   * The current UI theme.
   */
  readonly theme?: string;
  /**
   * Unique ID for the current Teams session for use in correlating telemetry data.
   */
  readonly sessionId?: string;
  /**
   * The type of the host client. Possible values are : android, ios, web, desktop, rigel
   */
  readonly hostClientType?: HostClientType;
  /**
   * Current ring ID
   */
  readonly ringId?: string;
  /**
   * Unique ID for the current session for use in correlating telemetry data.
   */
  readonly appSessionId?: string;
  /**
   * Time when the user clicked on the tab
   */
  readonly userClickTime?: number;
}

export interface GetContextResponse extends MessageResponse {
  readonly context: Context;
}

export type AuthCallback = (tokenResponses: TokenResponse[]) => void;
export type ContextCallback = (context: Context) => void;

export interface PerfMetrics {
  readonly FMP: number;
}

export interface PageLoadPerfMetrics extends Record<string, unknown> {
  readonly pageType: string;
  readonly perfMetrics?: PerfMetrics;
  readonly success: boolean;
}

export interface PageTitleDetails extends Record<string, unknown> {
  readonly title: string;
  readonly url: string;
}
